import { FunctionComponent, useEffect, useRef } from 'react';
import { AutocompleteFieldTypesRecord } from '../../configuration/fieldTypes';
import { stateOptions } from '../../stateOptions';
import { TransactionFieldProps } from './TransactionField';
import styles from './StateSelectField.module.scss';

const arrowIcon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
		{/* eslint-disable-next-line max-len */}
		<path d="M432.591 209.332L240.593 393.312C235.968 397.781 229.968 400 223.999 400S212.031 397.781 207.406 393.312L15.408 209.332C5.814 200.18 5.501 184.992 14.689 175.43C23.814 165.805 39.064 165.492 48.595 174.711L223.999 342.758L399.404 174.711C408.904 165.492 424.185 165.805 433.31 175.43C442.497 184.992 442.185 200.18 432.591 209.332Z" />
	</svg>
);

export const StateSelectField: FunctionComponent<TransactionFieldProps> = ({
	field,
	defaultValue,
	disabled,
	labelRef,
	showValidation,
	changeHandler,
	onBlur,
	useRefFunc = useRef,
	useEffectFunc = useEffect
}) => {
	const selectRef = useRefFunc<HTMLSelectElement>(null);

	useEffectFunc(() => {
		if (defaultValue) {
			setTimeout(() => {
				selectRef?.current?.dispatchEvent(new Event('change'));
			});
		}

		return () => {};
	}, []);

	useEffectFunc(() => {
		const changeListener = (event) => {
			const eventValue = event.target.value;
			field.SetValue(eventValue);
			changeHandler?.(event);
		};

		selectRef.current?.addEventListener('change', changeListener);

		return () => {
			selectRef.current?.removeEventListener('change', changeListener);
		};
	});

	return (
		<div className={styles.selectContainer}>
			{arrowIcon}
			<label htmlFor={field.Key} ref={labelRef}>
				{field.Label}
			</label>
			{/* eslint-disable-next-line enforce-ids-in-jsx/missing-ids */}
			<select
				ref={selectRef}
				id={field.Key}
				name={field.Key}
				defaultValue={field.GetValue() || defaultValue}
				disabled={disabled}
				onBlur={onBlur}
				autoComplete={AutocompleteFieldTypesRecord[field.Type]}
				data-testid="StateSelectFieldSelect"
			>
				<option id="selectAState" value="">
					Select a state
				</option>
				{stateOptions.map((option) => {
					const optionId = `${field.Key}Option_${option.value}`;
					return (
						<option id={optionId} value={option.value} key={option.value}>
							{option.label}
						</option>
					);
				})}
			</select>
			{showValidation && <p className={styles.validation}>{field.ValidationMessage}</p>}
		</div>
	);
};
